import { render, staticRenderFns } from "./milestone_task.vue?vue&type=template&id=053f9408"
import script from "./milestone_task.vue?vue&type=script&lang=js"
export * from "./milestone_task.vue?vue&type=script&lang=js"
import style0 from "./milestone_task.vue?vue&type=style&index=0&id=053f9408&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports